import { createQueryKeySet } from '~/utils/query-keys';
import { useQuery } from '@tanstack/react-query';
import { SSF } from '~/apis/api';

export type UseCategoriesListQueryParams = Parameters<typeof SSF.api.ageCategoriesList>[0];

export const keys = createQueryKeySet<UseCategoriesListQueryParams>('age_categories');

export function useCategoriesListQuery(params?: UseCategoriesListQueryParams) {
  return useQuery({
    queryFn: async () => {
      const { data } = await SSF.api.ageCategoriesList(params);
      return data;
    },
    queryKey: keys.list(params),
  });
}
